import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import ContentView from 'components/content';
import ContentSelection from 'components/contentSelection';
import Widgets from 'components/widgets';
import AdvancedSettings from 'components/settings';
import NDAList from 'components/nda/index';

import { Button } from 'react-bootstrap';

import CollectionWidgetManager from 'services/collections.widget.service';
import { attachContent, closeModal } from 'services/messages.service';
import { generateAnonymousLinksRequest } from 'actions/links';

import styles from './integration.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { fetchUserAccount, fetchUserProfile } from 'actions/users';
import { fetchIntegrations } from 'actions/integrations';
import AuthService from 'services/auth.service';

const widgetManager = new CollectionWidgetManager();

export default function GmailView(props) {
  const dispatch = useDispatch();


  const [attaching, setAttaching] = useState(false);

  useEffect(() => {
    dispatch(fetchUserAccount());
    dispatch(fetchUserProfile());
    dispatch(fetchIntegrations());
    
  }, []);

  const applicationContext = useSelector(state => _.get(state, `application`));
  const assets = useSelector(state => _.get(state, `application.assets`, []));
  const source = useSelector(state => _.get(state, `application.type`));
  const collection = useSelector(state => _.get(state, `application.collection`, null));
  const empty = collection == null && assets.length == 0;
  const [showNDAList, setShowNDAList] = useState(false);
  const [nda, setNda] = useState(null);


  const handleAttachContent = () => {
    setAttaching(true);

    const request = {
      type: "anonymous",
      ...(applicationContext.settings || {}),
    };

    var entities = [];
    if (collection) {
      entities = [collection];
    } else if (assets.length > 0) {
      entities = [...assets];
    }

    dispatch(generateAnonymousLinksRequest(entities, request, (response) => {
      const html = widgetManager.widget(response.widget).render(response);

      var context = {
        ...response,
        html: html
      }

      attachContent(context);
    }));
  }

  const handleNDAClick = () => {
    if(nda != null) {
      setNda(null);
    } else {
      setShowNDAList(!showNDAList);
    }
  }

  const handleNdaSelection = (nda) => {
    setNda(nda);
    setShowNDAList(!showNDAList);
  }

  const handleNDAChange = () => {
    setShowNDAList(!showNDAList);
  }

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <ContentView />
      </div>
      <div className={styles.right}>
        <div className={styles.inner}>
        {!showNDAList && 
          <>
            <ContentSelection />

            {!empty &&
              <>
                <Widgets />
                <AdvancedSettings onNDAToggle={handleNDAClick} nda={nda} source={source} onNDAChange={handleNDAChange}/>

                <div className={styles.actions}>
                  <Button variant='link' onClick={() => closeModal(applicationContext.id)} disabled={attaching}>Cancel</Button>
                  <Button variant='link' className={styles.attach} onClick={handleAttachContent} disabled={attaching}>
                    {attaching ? 'Attaching...' : 'Attach'}
                  </Button>
                </div>
              </>
            }
          </>
        }
        {showNDAList &&
          <div className={styles.backButton}>
            <Button variant='link' onClick={() => setShowNDAList(!showNDAList)}>
              <FontAwesomeIcon icon={faChevronLeft} size="sm" /> NDA Templates
            </Button>
            <NDAList onNDASelection={(nda) => handleNdaSelection(nda)}/>
          </div>
        }
        </div>
      </div>
    </div>
  )
}